import { render, staticRenderFns } from "./DaysList.vue?vue&type=template&id=2a82946d&scoped=true"
import script from "./DaysList.vue?vue&type=script&lang=js"
export * from "./DaysList.vue?vue&type=script&lang=js"
import style0 from "./DaysList.vue?vue&type=style&index=0&id=2a82946d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a82946d",
  null
  
)

export default component.exports